import { defaultActionFilters } from 'modules/automation-rules/actions/constants/default-action-filters'
import { defaultTriggerFilters } from 'modules/automation-rules/triggers/constants/default-trigger-filters'
import { AutomationRuleFilterInterface } from 'modules/automation-rules/types/automation-rule-filter-interface'

export const automationRuleDefaultFilters: AutomationRuleFilterInterface = {
  status: 'true',
  trigger: undefined,
  action: undefined,
  ...defaultTriggerFilters,
  ...defaultActionFilters,
}
